module.exports = __webpack_public_path__ + "img/Rectangle_21P.aef16919.png";